<!--
 * @Author: DQL
 * @Date: 2022-01-28 16:59:40
 * @LastEditors: DQL
 * @LastEditTime: 2022-02-14 16:56:38
 * @Description: 选择办理人组件
-->
<template>
  <el-dialog
    v-loading="isLoading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-70 o-dialog--xl-50"
    title="选择办理人"
    :visible.sync="show"
    :modal="false"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <section>
      <el-form
        ref="filterParams"
        class="c-form"
        :model="filterParams"
        :inline="true"
        label-position="right"
        label-width="100px"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="组织机构"
              prop="deptCode"
            >
              <hm-tree-select
                v-model="filterParams.deptCode"
                class="c-tree-select-wrap"
                instance-id="cTreeSelect"
                placeholder="请选择组织机构"
                loading-text="加载中..."
                :append-to-body="true"
                :clearable="false"
                :multiple="false"
                :options="deptList"
                :normalizer="normalizer"
                @input="handleChangeDept"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="岗位"
              prop="roleCode"
            >
              <el-select
                v-model="filterParams.roleCode"
                class="c-form__select"
                placeholder="请选择岗位"
                @change="handleGwChange"
              >
                <el-option
                  v-for="item in gwList"
                  :key="item.roleCode"
                  :label="item.roleName"
                  :value="item.roleCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      v-loading="loadingUser"
      class="c-flex-transfer u-mg-t-10"
    >
      <el-table
        ref="sourceTable"
        class="o-header-text-center"
        height="calc(400px)"
        stripe
        border
        :data="filterSourceData"
        @row-click="handleSourceRowClick"
        @selection-change="handleSourceSelection"
      >
        <el-table-column
          type="selection"
          width="34"
        />
        <el-table-column
          prop="username"
          label="待选列表"
        />
      </el-table>
      <div class="el-transfer__buttons">
        <el-button
          icon="el-icon-arrow-right"
          class="el-transfer__button"
          circle
          type="primary"
          :disabled="sourceSelectList.length<=0"
          @click="handleCheckToTarget"
        />
      </div>
      <el-table
        ref="targetTable"
        class="o-header-text-center"
        height="calc(400px)"
        stripe
        border
        :data="targetData"
      >
        <el-table-column
          width="44"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="handleDel(scope.row.userCode)"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="username"
          label="已选列表"
        />
      </el-table>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        :disabled="targetData.length<=0"
        @click="handleSave()"
      >
        保存
      </el-button>
      <el-button
        @click="handleClose()"
      >
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getDeptTree, getGwList, getUserList, completeSelect } from './blrSelect.service';

export default {
  name: 'BlrSelect',
  // 接口
  props: {
    // 机构范围
    deptFw: {
      validator: val => typeof val === 'string' || val === null,
      default: null,
      required: true
    },
    // 流程实例ID
    processInsId: {
      validator: val => typeof val === 'string' || val === null,
      default: null,
      required: true
    },
    // 任务ID
    taskId: {
      validator: val => typeof val === 'string' || val === null,
      default: null,
      required: true
    },
    // 审批结论
    condition: {
      type: [String, Number],
      default: function () {
        return null;
      }
    },
    // 是否回调
    isCallBack: {
      type: Boolean,
      default: true
    },
    // 加载状态
    isLoading: {
      type: Boolean
    },
    // 是否提交显示选人弹框
    isSubmit: {
      type: Boolean
    },
    // 是否多选
    multiple: {
      type: Boolean,
      default: true
    },
    // 多选限制个数
    multipleLimit: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      show: false,
      loadingUser: false, // 弹窗loading状态
      selectDisabled: false,

      /* 查询条件（页面绑定的查询条件） Start */
      filterParams: {
        deptCode: null,
        roleCode: null
      },
      /*  查询条件 End */

      deptList: [], // 组织机构下拉树
      gwList: [], // 岗位下拉框
      sourceData: [], // 待选列表数据
      targetData: [], // 已选列表数据
      sourceSelectList: [], // 待选列表用户数据
      sourceSelectId: null, // 待选列表勾选用户id
      targetSelectId: null, // 已选列表勾选用户id
      targetUserCodeList: [], // 已选列表用户数据
      users: [], // 选择的办理人员
      isSave: false // 保存标志
    };
  },
  computed: {
    /**
     * @description: 判断是否显示选人页面弹窗
     * @param {*}
     * @return {*}
     */
    isShow () {
      return this.isSubmit;
    },
    /**
     * @description:  以 / 分割用户id数据
     * @param {*}
     * @return {*}
     */
    filterSourceData () {
      const _DmStr = '/' + this.targetUserCodeList.join('/') + '/';
      const _list = this.sourceData.filter(item => _DmStr.indexOf(item.userCode) < 0);
      return _list;
    }
  },
  methods: {
    /**
     * @description: 转换下拉树节点字段
     * @param {*}
     * @return {*}
     */
    normalizer (node) {
      return {
        id: node.deptCode,
        label: node.deptname,
        children:
          node.children && node.children.length > 0 ? node.children : undefined
      };
    },
    /**
     * @description: 关闭弹窗
     * @param {*}
     * @return {*}
     */
    handleClose () {
      this.show = false;
      if (this.isCallBack && this.isSave) {
        this.$emit('update:isLoading', true);
      }
      this.$emit('update:isSubmit', false);
    },
    /**
     * @description: 保存按钮点击事件
     * @param {*}
     * @return {*}
     */
    handleSave () {
      this.isSave = true;
      if (this.isCallBack) {
        // 将人员数据返回给调用页面，由调用页面的@submitCallback回调方法实现
        this.$emit('submitCallback', this.targetData);
        this.handleClose();
      } else {
        // 直接提交完成该工作项
        this.handleSubmit();
      }
    },
    /**
     * @description: 获取税务机关数据
     * @param {*}
     * @return {*}
     */
    handleGetDeptTree () {
      this.$emit('update:isLoading', true);
      getDeptTree(this.processInsId, this.taskId, { deptFw: this.deptFw, condition: this.condition })
        .then(rsp => {
          const _list = rsp.data;
          if (_list.length === 0) {
            this.handleSave();
          } else {
            this.$emit('update:isLoading', false);
            this.deptList = rsp.data;
            this.show = true;
            if (rsp.data.length === 1) {
              this.filterParams.deptCode = rsp.data[0].deptCode;
              this.handleGetGwList();
            }
          }
        })
        .catch(() => {
          this.$emit('update:isLoading', false);
          this.$emit('update:isSubmit', false);
        });
    },
    /**
     * @description: 获取岗位数据
     * @param {*}
     * @return {*}
     */
    handleGetGwList () {
      this.selectDisabled = true;
      getGwList(this.processInsId, this.taskId, { condition: this.condition, deptCode: this.filterParams.deptCode })
        .then(rsp => {
          this.gwList = rsp.data;
          if (rsp.data.length === 1) {
            this.filterParams.roleCode = rsp.data[0].roleCode;
            this.handleGetUserList();
          }
        })
        .catch(() => {
          this.selectDisabled = false;
          this.$emit('update:isLoading', false);
          this.$emit('update:isSubmit', false);
        });
    },
    /**
     * @description: 获取税务人员数据
     * @param {*}
     * @return {*}
     */
    handleGetUserList () {
      getUserList(this.processInsId, this.taskId, this.filterParams)
        .then(rsp => {
          this.sourceData = rsp.data;
          this.selectDisabled = false;
        })
        .catch(() => {
          this.selectDisabled = false;
          this.$emit('update:isLoading', false);
          this.$emit('update:isSubmit', false);
        });
    },
    /**
     * @description: 根据办理人数据提交该工作项
     * @param {*}
     * @return {*}
     */
    handleSubmit () {
      if (this.targetData.length <= 0) {
        this.$alert('请至少选择至少一个办理人', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        });
        return;
      }
      // 提交工作项
      completeSelect(this.processInsId, this.taskId, { condition: this.condition, users: this.targetData })
        .then(rsp => {
          this.handleClose();
          this.$emit('completeCallback');
          this.$alert(rsp.data.data, '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
          });
        })
        .catch(() => {
        });
    },
    /**
     * @description: 组织机构修改事件
     * @param {*}
     * @return {*}
     */
    handleChangeDept () {
      // this.loadingUser = true;
      this.handleGetGwList();
    },
    /**
     * @description: 岗位修改事件
     * @param {*}
     * @return {*}
     */
    handleGwChange () {
      // this.loadingUser = true;
      this.getUserList();
    },
    /**
     * @description: 在已选列表中删除办理人员
     * @param {*}
     * @return {*}
     */
    handleDel (userCode) {
      this.targetData = this.targetData.filter(item => item.userCode !== userCode);
      this.targetUserCodeList = this.targetUserCodeList.filter(item => item !== userCode);
    },
    /**
     * @description: 可选数据点击行勾选
     * @param {*}
     * @return {*}
     */
    handleSourceRowClick (row, column, event) {
      this.$refs.sourceTable.toggleRowSelection(row);
    },
    /**
     * @description: 待选列表到已选列表
     * @param {*}
     * @return {*}
     */
    handleCheckToTarget () {
      const addList = this.sourceSelectList.map(item => { return item.userCode; });
      this.targetUserCodeList = this.targetUserCodeList.concat(addList);
      this.targetData = this.targetData.concat(this.sourceSelectList);
    },
    /**
     * @description: 待选表格Select事件
     * @param {*}
     * @return {*}
     */
    handleSourceSelection (val) {
      this.sourceSelectList = JSON.parse(JSON.stringify(val));
      const _arr = val.map(item => {
        return item.userCode;
      });
      this.sourceSelectId = '/' + _arr.join('/') + '/';
    }
  },
  watch: {
    isShow (newVal, oldVal) {
      if (newVal) {
        this.handleGetDeptTree();
      }
    }
  },
  mounted () {
    // this.handleGetDeptTree();
  }
};
</script>
